import React, { useState, useEffect } from "react";
import ScoreBar from "../../../../../shared/components/ScoreBar/ScoreBar";
import "./Performance.scss";

const Performance = ({ performanceData, totalPossible }) => {
  const [selectedMetric, setSelectedMetric] = useState(null);

  useEffect(() => {
    if (performanceData && performanceData.length > 0) {
      setSelectedMetric(performanceData[0].label);
    }
  }, [performanceData]);

  if (!performanceData || performanceData.length === 0) return null;

  const selectedData = performanceData.find(
    (item) => item.label === selectedMetric
  );

  return (
    <div className="performance-container">
      <div className="performance-header">
        <label className="performance-label">View Performance by:</label>
        <select
          className="performance-select"
          value={selectedMetric || ""}
          onChange={(e) => setSelectedMetric(e.target.value)}
        >
          {performanceData.map((item) => (
            <option key={item.label} value={item.label}>
              {item.label}
            </option>
          ))}
        </select>
      </div>

      {selectedData && (
        <div className="performance-bars">
          <ScoreBar
            label="Average Students"
            score={selectedData.average}
            color="#E9B008"
            subLabel="Average"
            metricType={selectedMetric}
            totalPossible={totalPossible}
          />
          <ScoreBar
            label="Your Performance"
            score={selectedData.your}
            color="#0066FF"
            subLabel="Your"
            metricType={selectedMetric}
            totalPossible={totalPossible}
          />
          <ScoreBar
            label="Topper Students"
            score={selectedData.topper}
            color="#16A34A"
            subLabel="Topper"
            metricType={selectedMetric}
            totalPossible={totalPossible}
          />
        </div>
      )}
    </div>
  );
};

export default Performance;
